import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
class NoticeBoardPreview extends Component {
    render() {
        const {
            isBackground,
            logoPosition,
            Background,
            backgroundImage,
            logoIcon, text } = this.props;


        const bgstyleImg = backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : { height: '100%' }

        const bgstyleColor = Background ? { backgroundColor: Background } : { height: '100%' }
        return <div style={isBackground ? bgstyleImg : bgstyleColor} className="nb_wrap_00">
            <div className="nb_wrap_in_001">
                {logoIcon && <div className="nbtd_logo_icon" style={{ 'justifyContent': logoPosition }}>
                    <img src={logoIcon} className="nbtd_logo_icon_img" alt="logo" />
                </div>}
                {text && <div className="ql-editor" style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'break-spaces'
                }}> {ReactHtmlParser(text)}</div>}
            </div>
        </div>
    }
}

export default NoticeBoardPreview